<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Orders</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.orders.index')">
                                    Orders
                                </Link>
                            </li>
                            <li class="breadcrumb-item active"> {{ isEditing ? "Edit" : "Add" }} Order
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form class="create-order-form">
                        <h4 class="form-section"><i
                            class="feather icon-info"></i>
                            Order Details
                        </h4>
                        <div class="row">
                            <div style="margin-left: 20px;" class="col-md-5 column-border">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-title">GENERAL</div>
                                        <div class="card-group__body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="form-group"><label
                                                        for="">Delivery
                                                        Type</label>
                                                        <div class="d-flex align-items-center">
                                                            <fieldset class="radio">
                                                                <label>
                                                                    <input type="radio" name="delivery-type"
                                                                           v-model="order.type"
                                                                           @click="order.payment_channel = ''"
                                                                           value="DELIVERY">
                                                                    Delivery
                                                                </label>
                                                            </fieldset>
                                                            <fieldset class="radio ml-2">
                                                                <label>
                                                                    <input type="radio" name="delivery-type"
                                                                           v-model="order.type" value="PICKUP">
                                                                    Pickup
                                                                    from store
                                                                </label>
                                                            </fieldset>
                                                            <div v-if="order.errors.type"
                                                                 class="text-danger text-small">
                                                                {{ order.errors.type }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row align-items-end">
                                                <div :class="order.type === 'DELIVERY' ? 'col-md-6' : 'col-md-12'">
                                                    <div class="form-group mb-0">
                                                        <label for="store-select">Choose Store</label>
                                                        <v-select id="store-select" class="customer-search" label="name"
                                                                  v-model="order.store" :options="stores">
                                                            <template slot="no-options"> Choose Store
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center"><span>{{
                                                                        option.name
                                                                    }}</span><br/>
                                                                    <small>{{ option.area }}, {{
                                                                            option.city.name
                                                                        }}</small></div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center text-truncate"><span>{{
                                                                        option.name
                                                                    }}</span></div>
                                                            </template>
                                                        </v-select>
                                                    </div>
                                                </div>

                                                <div class="col-md-6" v-if="order.type=='DELIVERY'">
                                                    <div class="form-group mb-0">
                                                        <label for="map">Delivery Address</label>
                                                        <v-select
                                                            id="map"
                                                            class="customer-search"
                                                            v-model="place"
                                                            :disabled="!order.store"
                                                            :options="places"
                                                            label="label"
                                                            placeholder="Start typing"
                                                            @search="autocompleteSearch"
                                                        ></v-select>
                                                    </div>
                                                </div>
                                                <div class="col-12" v-if="outOfCoverageMessage"><span
                                                    class="badge badge-danger"> {{ outOfCoverageMessage }} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1"></div>
                            <div class="col-md-5 column-border"
                                 v-if="isEditing || (order.type && order.store && hasLocation && !outOfCoverageMessage)">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-title">CUSTOMER DETAILS</div>
                                        <div class="row align-items-end" v-if="!isEditing">
                                            <div class="col-md-6">
                                                <div class="form-group mb-md-0">
                                                    <label for="new-customer">New Customer?</label>
                                                    <div class="form-check mt-1">
                                                        <input id="new-customer" type="checkbox"
                                                               class="form-check-input"
                                                               v-model="newCustomer">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6" v-if="!newCustomer">
                                                <div class="form-group mb-md-0"><label
                                                    for="customer-search">Customer</label>
                                                    <v-select id="customer-search" class="customer-search"
                                                              label="name" v-model="order.customer"
                                                              :filterable="false" :options="customers"
                                                              @search="onSearch">
                                                        <template slot="no-options"> Search by Name, email or phone number
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center"><small> {{ option.email }},
                                                                {{ option.phone }} </small> <br/> <span> {{
                                                                    option.first_name + ' ' + option.last_name
                                                                }} </span></div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center text-truncate"><span> {{
                                                                    option.first_name + ' ' + option.last_name
                                                                }} </span></div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                        </div>

                                        <p v-if="!newCustomer && order.customer?.first_name"
                                           class="customer-balance-line text-success mb-0">
                                            <b>Customer Balance: &#8358;{{ formatNumber(order.customer.balance ?? 0) }}</b>
                                        </p>

                                        <template v-if="newCustomer || (order.customer.first_name)">

                                            <div class="row customer-details-fields">
                                                <div class="col-md-6">
                                                    <div class="form-group"><label
                                                        for="first_name">First
                                                        Name</label>
                                                        <input id="first_name" type="text"
                                                               class="form-control form-control-sm"
                                                               :disabled="!!isEditing"
                                                               v-model="order.customer.first_name">
                                                    </div>
                                                    <div v-if="order.errors.first_name" class="text-danger text-small">
                                                        {{ order.errors.first_name }}
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group"><label
                                                        for="last_name">Last
                                                        Name</label>
                                                        <input id="last_name" type="text"
                                                               class="form-control form-control-sm"
                                                               :disabled="!!isEditing"
                                                               v-model="order.customer.last_name">
                                                    </div>
                                                    <div v-if="order.errors.last_name" class="text-danger text-small">
                                                        {{ order.errors.last_name }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group"><label
                                                        for="email">Email
                                                        Address</label> <input id="email" type="text"
                                                                               class="form-control form-control-sm"
                                                                               :disabled="!!isEditing"
                                                                               v-model="order.customer.email">
                                                    </div>
                                                    <div v-if="order.errors.email" class="text-danger text-small">
                                                        {{ order.errors.email }}
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group"><label
                                                        for="phone">Phone</label>
                                                        <input id="phone" type="text"
                                                               class="form-control form-control-sm"
                                                               :disabled="!!isEditing"
                                                               v-model="order.customer.phone">
                                                    </div>
                                                    <div v-if="order.errors.phone_number"
                                                         class="text-danger text-small">
                                                        {{ order.errors.phone_number }}
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!--                            </template>-->
                        </div>

                        <div class="row">
                            <div style="margin-left: 20px;" class="col-md-5 column-border"
                                 v-if="isEditing || (order.type && order.store && hasLocation && !outOfCoverageMessage)">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-title">
                                            {{ order.type === 'DELIVERY' ? "Billing & Shipping" : 'Billing' }}
                                        </div>
                                        <div class="card-group__body">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="payment-method">Payment Channel</label>
                                                        <select id="payment-method" v-model="order.payment_channel"
                                                                class="form-control form-control-sm"
                                                                :disabled="isEditing" required>
                                                            <option value="">Select payment method</option>
                                                            <option v-for="(value,key) in paymentMethods" :key="key"
                                                                    :value="value"> {{ value }}
                                                            </option>
                                                        </select>
                                                        <div v-if="order.errors.payment_channel"
                                                             class="text-danger text-small">
                                                            {{ order.errors.payment_channel }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="first_name_recipient">Created At</label>
                                                        <input id="first_name_recipient" type="datetime-local"
                                                               class="form-control form-control-sm"
                                                               v-model="order.created_at">
                                                    </div>
                                                </div>

                                                <template v-if="order.type === 'DELIVERY'">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="house_number">House Address</label>
                                                            <input id="house_number" type="text"
                                                                   class="form-control form-control-sm"
                                                                   v-model="order.address">
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="house_number">Longitude</label>
                                                            <input id="house_number" type="text"
                                                                   class="form-control form-control-sm" disabled
                                                                   v-model="order.longitude">
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="house_number">Latitude</label>
                                                            <input id="house_number" type="text" disabled
                                                                   v-model="order.latitude"
                                                                   class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1"></div>
                            <div class="col-md-5 column-border"
                                 v-if="isEditing || (order.type && order.store && hasLocation && !outOfCoverageMessage)">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-title">RECIPIENT DETAILS</div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="recipient_first_name">First Name</label>
                                                    <input id="recipient_first_name" type="text"
                                                           v-model="order.recipient.first_name"
                                                           class="form-control form-control-sm">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="recipient_last_name">Last name</label>
                                                    <input id="recipient_last_name" type="text"
                                                           v-model="order.recipient.last_name"
                                                           class="form-control form-control-sm">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="recipient_email_address">Email Address</label>
                                                    <input id="recipient_email_address" type="text"
                                                           v-model="order.recipient.email"
                                                           class="form-control form-control-sm">
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="recipient_phone">Phone</label>
                                                    <input id="recipient_phone" type="text"
                                                           v-model="order.recipient.phone"
                                                           class="form-control form-control-sm">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div style="margin-left: 20px;" class="col-md-5 column-border"
                                 v-if="isEditing || (order.type && order.store && hasLocation && !outOfCoverageMessage)">
                                <div>DELIVERY INSTRUCTIONS</div>
                                <div class="form-group">
                                    <textarea id="order-note" rows="2" class="form-control form-control-sm"
                                              v-model="order.delivery_instruction"
                                              style="height: 55px;"></textarea>
                                </div>
                            </div>
                            <div class="col-md-1"></div>
                            <div class="col-md-5 column-border"
                                 v-if="isEditing || (order.type && order.store && hasLocation && !outOfCoverageMessage)">
                                <div>Ordered From</div>
                                <div class="form-group">
                                    <select class="form-control form-control-sm" v-model="order.ordered_from">
                                        <option value="">Select the Platform</option>
                                        <option v-for="(key,platform) in platforms" :key="key"
                                                :value="key">
                                            {{ platform }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

            <section class="card"
                     v-if="isEditing || (order.type && order.store && hasLocation && !outOfCoverageMessage)">
                <div class="card-body">
                    <div class="card-title">
                        <h4 class="form-section">
                            <i class="feather icon-shopping-cart"></i> Order Items
                            <button @click="showOrderItems = !showOrderItems"
                                    class="btn btn-outline-primary pull-right float-right" type="button"
                                    v-if="isEditing || ((order.type==='DELIVERY' && order.longitude || order.type==='PICKUP') && order.store && !outOfCoverageMessage)">
                                <i class="feather icon-plus-circle icon-left"></i> Add Item(s)
                            </button>
                        </h4>
                    </div>
                    <form @submit.prevent="addItems" v-if="showOrderItems">
                        <div class="modal-body" v-if="order.store">
                            <template v-for="(item, index) in order.order_items">
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group"><label>Product</label> <br>
                                            <v-select class="order-items-search" label="name"
                                                      v-model="item.product" :options="storeProducts"
                                                      @input="populateProductSizes(index,item.product)"

                                                      max-height="50px">
                                                <template slot="no-options"> Choose Product</template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        <!--                                                        <img-->
                                                        <!--                                                            :src="option.image_url.image_url" width="40px">-->
                                                        <span
                                                            class="ml-1">{{ option.name }}</span>
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        <!--                                                        <img-->
                                                        <!--                                                        :src="option.image_url.image_url" height="28px">-->
                                                        <span
                                                            class="ml-1">{{ option.name }}</span></div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <template v-if="order.product_sizes[index]">
                                        <div class="col-md-3">
                                            <label>Choose Size</label>
                                            <select class="form-control form-control-sm" required
                                                    v-model="item.size_id"
                                                    @change="populateProductPrice(index, item.size_id)"
                                            >
                                                <option value=""> Select Size</option>
                                                <option
                                                    v-for="(size, index) in order.product_sizes[index]"
                                                    :key="index"
                                                    :value="size.id">
                                                    {{ size.name }} (₦ {{
                                                        size.pivot.discount_price === null ? formatNumber(size.pivot.price) : formatNumber(size.pivot.discount_price)
                                                    }})
                                                    {{ size.pivot.discount_price === null ? '' : '(discount price)' }}
                                                </option>
                                            </select>
                                        </div>
                                    </template>

                                    <template v-if="order.ingredients[index]">
                                        <template v-if="order.ingredients[index].length > 0">
                                            <div class="col-md-3">
                                                <label class="form-label">Remove Ingredients</label>
                                                <v-select class="order-items-search" multiple v-model="item.ingredients"
                                                          :options="order.ingredients[index]"
                                                          label="name"
                                                          :reduce="name => name.id">
                                                </v-select>
                                            </div>
                                        </template>
                                    </template>

                                    <template v-if="order.has_toppings[index] && !order.is_my_pizza_jungle[index]">
                                        <div class="col-md-3">
                                            <label>Choose Toppings</label>
                                            <v-select class="order-items-search" multiple v-model="item.toppings"
                                                      :options="dataToppings"
                                                      label="description"
                                                      :reduce="name => name.id">
                                            </v-select>
                                        </div>
                                    </template>

                                    <template v-if="order.is_my_pizza_jungle[index]">
                                        <div class="col-md-3">
                                            <label>Choose Free Toppings</label>
                                            <v-select class="order-items-search" multiple v-model="item.free_toppings"
                                                      :options="dataToppings"
                                                      label="description"
                                                      :selectable="() => (!item.free_toppings || (item.free_toppings && item.free_toppings.length < 3))"
                                                      :reduce="name => name.id">
                                            </v-select>
                                        </div>
                                    </template>

                                    <template v-if="order.is_my_pizza_jungle[index]">
                                        <div class="col-md-3">
                                            <label>Choose Additional Toppings</label>
                                            <v-select class="order-items-search" multiple v-model="item.additional_toppings"
                                                      :options="dataToppings"
                                                      label="description"
                                                      :selectable="() => (!item.additional_toppings || (item.additional_toppings && item.additional_toppings.length < 3))"
                                                      :reduce="name => name.id">
                                            </v-select>
                                        </div>
                                    </template>

                                    <input type="checkbox" :checked="order.is_my_pizza_jungle[index]"
                                           v-model="item.is_my_pizza_jungle" id="myCheckbox" style="display: none;">

                                    <div class="col-md-3">
                                        <div class="form-group"><label>Quantity</label> <br> <input
                                            v-model="item.quantity" type="number" class="form-control form-control-sm" min="1"
                                            placeholder="Quantity" required></div>
                                    </div>

                                    <template v-if="order.has_crust[index]">
                                        <div class="col-md-3">
                                            <label>Choose Crust</label>
                                            <select class="form-control form-control-sm" required v-model="item.pizza_crust">
                                                <option value=""> Select Crust</option>
                                                <option value="traditional">Traditional Crust</option>
                                                <option value="thin">Thin Crust</option>
                                            </select>
                                        </div>
                                    </template>

                                </div>

                                <div class="row">
                                    <div class="col-md-3 variant-actions mb-3">
                                        <a href="#" @click.prevent="addNewRow(index)">
                                            <i class="feather icon-plus-circle"></i> Add
                                        </a> |
                                        <a href="#"
                                           @click.prevent="removeRow(index)"
                                           class="text-danger">
                                            <i class="feather icon-minus-circle"></i> Remove
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                    :disabled="isLoading"> Save changes <i class="fa fa-spinner spinner"
                                                                           v-if="isLoading"></i>
                            </button>
                        </div>
                    </form>

                    <div class="table-responsive"
                         v-if="!showOrderItems && (isEditing || ((order.type==='DELIVERY' && order.longitude || order.type==='PICKUP') &&order.type && order.store && !outOfCoverageMessage))">
                        <table id="users-list-datatable" class="table">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th width="100px">Product image</th>
                                <th>Product</th>
                                <th>Toppings</th>
                                <th>Ingredients</th>
                                <th>Cost (₦)</th>
                                <th>Quantity</th>
                                <th class="text-right">Total (₦)</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in order.order_items" :key="item.id">
                                <template v-if="item.product">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <img class="img-fluid" :src="item.image_url" alt="">
                                    </td>
                                    <td>
                                        <span> {{ item.product.name }}({{ item.size.name }}) </span>
                                        <br>
                                        <span v-if="item.pizza_crust">Crust:{{ item.pizza_crust }}</span>
                                    </td>
                                    <td>
                                        <template v-for="topping in item.toppings">
                                            {{
                                                dataToppings.find(toppingData => toppingData.id == topping).topping_name
                                            }},
                                        </template>
                                    </td>
                                    <td>
                                        <template v-for="ingredient in item.ingredients">
                                            {{
                                                item.product.ingredients.find(ingredientData => ingredientData.id === ingredient).name
                                            }},
                                        </template>
                                    </td>
                                    <td>
                                        <span> {{
                                                formatNumber(item.price)
                                            }} </span></td>
                                    <td>{{ item.quantity }}</td>
                                    <td class="text-right"> {{ formatNumber(item.subtotal) }}</td>
                                </template>
                            </tr>
                            <tr>
                                <td></td>
                                <td colspan="6">Subtotal</td>
                                <td class="text-right">₦ {{ formatNumber(subTotal) }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td colspan="6">Shipping:</td>
                                <td class="text-right"> ₦ {{ formatNumber(shippingFee) }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td colspan="6">Promo Code</td>
                                <td class="text-right">
                                    <input type="text" class="form-control col-12" :disabled="isEditing"
                                           v-model="order.promo_code">
                                    <div v-if="order.errors.promo_code" class="text-danger text-small">
                                        {{ order.errors.promo_code }}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td colspan="6">Customer Balance:</td>
                                <td class="text-right"> ₦ {{
                                        formatNumber((!newCustomer ? order.customer.balance : 0))
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <th colspan="6">Total</th>
                                <th class="text-right">₦{{ formatNumber(total) }}</th>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <button @click="makeOrder" class="btn btn-primary glow float-right mb-1 mb-sm-0 mr-0"
                            v-if="!showOrderItems && ((order.type==='DELIVERY' && order.longitude || order.type==='PICKUP') && order.type && order.store && !outOfCoverageMessage)"
                            :disabled="!order.order_items[0].quantity || saving">
                        {{ isEditing ? 'Update Order' : 'Create Order' }} <i class="fa fa-spinner spinner"
                                                                             v-if="saving"></i>
                    </button>

                    <template v-if="dataOnlinePayment.includes(order.payment_channel)">
                        <button @click="generatePaymentLink"
                                class="btn btn-outline-primary glow float-right mb-1 mb-sm-0 mr-4"
                                v-if="!showOrderItems && (order.type && order.store  && !outOfCoverageMessage)"
                                :disabled="!order.order_items[0].quantity || saving">
                            Copy Payment Link<i class="fa fa-spinner spinner"
                                                v-if="saving"></i>
                        </button>
                    </template>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";
import {v4 as uuidv4} from "uuid";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
    metaInfo: {title: 'Create Order'},
    name: 'OrderCreate',
    props: [
        'isEditing',
        'dataStores',
        'dataPaymentMethods',
        'dataToppings',
        'platforms',
        'dataOnlinePayment',
        'dataPaymentLink',
        'orderData',
        'googleApiKey'
    ],
    components: {
        Link,
        VueGoogleAutocomplete,
    },
    layout: Layout,
    data() {
        return {
            saving: false,
            showAddressInput: true,
            field1: '',
            order: this.$inertia.form({
                address: null,
                latitude: null,
                longitude: null,
                ordered_from: "admin",
                first_name: null,
                last_name: null,
                email: null,
                phone_number: null,
                use_loyalty_points: false,
                delivery_instruction: null,
                promo_code: null,
                store_id: null,
                payment_channel: '',
                order_items: [{
                    quantity: '',
                    product_id: '',
                    ingredients: [],
                    pizza_crust: "",
                    toppings: [],
                    free_toppings: [],
                    additional_toppings: [],
                    is_my_pizza_jungle: false
                }],
                customer: {first_name: '', last_name: '', house_number: ''},
                recipient: {first_name: '', last_name: '', house_number: ''},
                type: 'DELIVERY',
                product_sizes: [],
                ingredients: [],
                has_toppings: [],
                has_crust: [],
                is_my_pizza_jungle: [],
                my_pizza_jungle: [],
            }),
            customers: [],
            newCustomer: false,
            cities: [],
            paymentMethods: [],
            isLoading: false,
            stores: [],
            storeProducts: [],
            shippingFee: 0,
            outOfCoverageMessage: '',
            user: {},
            store: {},
            hasLocation: false,
            oldStoreId: null,
            paymentMethodError: false,
            showOrderItems: false,
            updateRecipient: false,
            isWatchEnabled: true,
            places: [],
            place: null
        }
    },
    methods: {
        buildQueryString(params) {
            return Object.keys(params)
                .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(params[key]))
                .join("&");
        },
        generatePaymentLink() {
            const baseUrl = this.dataPaymentLink;
            const queryParams = {
                amount: this.total,
                email: this.order.customer.email,
                firstname: this.order.customer.first_name,
                lastname: this.order.customer.last_name,
            };

            const queryString = this.buildQueryString(queryParams);
            const fullUrl = `${baseUrl}?${queryString}`;

            const tempInput = document.createElement('input');
            tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
            tempInput.value = fullUrl;
            document.body.appendChild(tempInput);
            tempInput.select();

            try {
                this.saving = true;
                const successful = document.execCommand('copy');
                if (successful) {
                    this.saving = false;
                    console.log('Text copied to clipboard');
                } else {
                    this.saving = false;
                    console.error('Failed to copy text');
                }
            } catch (err) {
                this.saving = false;
                console.error('Unable to copy text: ', err);
            }

            document.body.removeChild(tempInput);
        },
        async addressAutocompleteSearch(placeResultData) {
            // let country = '';
            // let state = '';
            // let locality = '';
            // let route = addressData.route;
            //
            // placeResultData.address_components.forEach(addr => {
            //
            //     if (addr.types.includes('country')) {
            //         country = addr.long_name;
            //     }
            //     if (addr.types.includes('administrative_area_level_1')) {
            //         state = addr.long_name;
            //     }
            //     if (addr.types.includes("locality")) {
            //         locality = addr.long_name;
            //     }
            // })

            this.order.latitude = placeResultData.location.latitude;
            this.order.longitude = placeResultData.location.longitude;
            this.order.address = placeResultData.formattedAddress;

            // await this.getAddressData({longitude, latitude, address}, true)
        },

        autocompleteSearch(searchTerm) {
            if (searchTerm.length < 5) {
                this.places = [];

                return;
            }

            let apiKey = this.googleApiKey;
            let sessionToken = uuidv4();

            axios.post(
                `https://places.googleapis.com/v1/places:autocomplete?key=${apiKey}`,
                {
                    input: searchTerm,
                    sessionToken: sessionToken,
                    includedRegionCodes: "NG"
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Goog-FieldMask': 'suggestions.placePrediction.text.text,suggestions.placePrediction.placeId'
                    }
                }
            ).then(response => {
                this.places = response.data.suggestions.map(suggestion => ({
                    label: suggestion.placePrediction.text.text,
                    value: {
                        placeId:  suggestion.placePrediction.placeId,
                        sessionToken: sessionToken
                    }
                }));
            }).catch(error => {
                console.error('Google Autocomplete Places error:', error)
            })

        },

        async getAddressData({longitude, latitude, address}) {
            if (this.user.user_type === 'store_manager') {
                if (!this.isEditing) {
                    this.order.order_items = [{
                        quantity: '',
                        product_id: '',
                        size_id: '',
                        price: '',
                        image_url: ''
                    }];
                }
                await this.fetchStoreProduct(this.store.id);
            }
            this.hasLocation = true;

            if (this.order.store) {
                const {
                    data: {
                        distance,
                        delivery_price,
                        out_of_range
                    }
                } = await axios.post(route('admin.orders.calculate-shipping', this.order.store.id), this.order);
                this.outOfCoverageMessage = '';
                if (out_of_range && this.order.type === 'DELIVERY') {
                    this.outOfCoverageMessage = 'Selected Location is out of coverage!';
                    return;
                }
                this.shippingFee = this.order.type === 'DELIVERY' ? delivery_price : 0;
            }
        },

        async fetchStoreProduct(restaurantId) {
            const response = await axios.get(route('admin.products.all-products', restaurantId));

            this.storeProducts = response.data.data.map(product => ({
                id: product.id,
                name: product.name,
                price: product.price,
                sizes: product.sizes,
                ingredients: product.ingredients,
                image_url: product.product_images[0],
                has_toppings: product.has_toppings,
                has_crust: product.has_crust,
                is_my_pizza_jungle: product.name.toLowerCase().replace(/[^a-z]/g, '') === "mypizzajungle"
            }));
        },

        updateOrderItems() {
            this.order.order_items = [{
                quantity: '',
                product_id: '',
                size_id: '',
                price: '',
                image_url: '',
                ingredients: [],
                pizza_crust: null,
                toppings: [],
            }];
        },

        updateOldStoreId(newStoreId) {
            this.oldStoreId = newStoreId;
        },

        onSearch(search, loading) {
            if (search.length >= 3) {
                loading(true);
                this.search(loading, search, this);
            }
        },

        search: _.debounce((loading, search, vm) => {
            axios.get(route('admin.customers.search', {
                keyword: search.trim()
            })).then(({data: {data}}) => {
                vm.customers = data;
                loading(false);
            });
        }, 1000),

        addItems() {
            this.isWatchEnabled = false;
            this.order.order_items = this.order.order_items.map(item => {
                const itemPrice = item.price;
                let toppingPrice = 0;

                item.toppings.map(item => {
                    let topping = this.dataToppings.find((element) => element.id === item);
                    toppingPrice += Number(topping.price);
                })

                if (item.additional_toppings) {
                    item.additional_toppings.map(item => {
                        let topping = this.dataToppings.find((element) => element.id === item);
                        toppingPrice += Number(topping.price);
                    });
                }

                return {
                    ...item,
                    cost: itemPrice,
                    subtotal: (+itemPrice * item.quantity) + (+toppingPrice * item.quantity)
                }
            });
            this.showOrderItems = false;
            this.isWatchEnabled = true;
        },

        formatNumber(x) {
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        },

        addNewRow(index) {
            this.isWatchEnabled = false;
            this.order.order_items.splice(index + 1, 0, {
                quantity: '',
                product_id: '',
                size_id: '',
                price: '',
                image_url: '',
                ingredients: [],
                toppings: [],
            })
            this.isWatchEnabled = true;
        },

        removeRow(index) {
            this.isWatchEnabled = false;
            this.order.order_items.splice(index, 1);
            if (this.order.order_items.length === 0) {
                this.order.order_items = [{
                    quantity: '',
                    product_id: '',
                    size_id: '',
                    price: '',
                    image_url: '',
                    ingredients: [],
                    toppings: [],
                }]
            }
            this.isWatchEnabled = true;
        },

        populateProductSizes(index, product) {
            this.order.product_sizes[index] = product.sizes
            this.order.order_items[index].product_id = product.id;
            this.order.order_items[index].image_url = product.image_url.image_url;

            this.order.ingredients[index] = product.ingredients
            this.order.has_toppings[index] = product.has_toppings
            this.order.has_crust[index] = product.has_crust

            this.order.order_items[index].ingredients = [];
            product.ingredients.forEach((item) => this.order.order_items[index].ingredients.push(item.id));
            this.order.is_my_pizza_jungle[index] = product.name.toLowerCase().replace(/[^a-z]/g, '') === "mypizzajungle"
        },

        populateProductPrice(index, selectedSize) {
            const size = this.order.product_sizes[index].find(size => selectedSize === size.id);
            this.order.order_items[index].price = size.pivot.discount_price === null ? size.pivot.price : size.pivot.discount_price;
            this.order.order_items[index].size = size;
        },

        async makeOrder() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    $('ul.navigation.navigation-main li.active').removeClass('active');
                },
                onError: () => {
                    this.saving = false;
                }
            };
            this.order.first_name = this.order.customer.first_name
            this.order.last_name = this.order.customer.last_name
            this.order.email = this.order.customer.email
            this.order.phone_number = this.order.customer.phone
            this.order.store_id = this.order.store.id;
            this.order.delivery_phone = this.order.recipient.phone
            this.order.delivery_name = this.order.recipient.first_name + this.order.recipient.last_name

            for (let i = 0; i < this.order.order_items.length; i++) {
                const orderItem = this.order.order_items[i];
                if (orderItem.product.name.toLowerCase().replace(/[^a-z]/g, '') === "mypizzajungle") {
                    if (!this.order.my_pizza_jungle) {
                        this.$set(this.order, 'my_pizza_jungle', []);
                    }
                    this.order.my_pizza_jungle.push(orderItem);
                    this.order.order_items.splice(i, 1);
                }
            }

            if (this.isEditing) {
                this.order.post(route('admin.orders.update', this.orderData.id), options);
            } else {
                this.order.post(route('admin.orders.store'), options);
            }
        },

        mountOrder() {
            this.order.type = this.orderData.type
            if (this.orderData.type === "DELIVERY") {
                this.order.address = this.orderData.address.address
                this.order.latitude = this.orderData.address.latitude
                this.order.longitude = this.orderData.address.longitude
            }

            this.order.promo_code = this.orderData.promo_code
            this.order.ordered_from = this.orderData.ordered_from
            this.order.phone_number = this.orderData.user.phone
            this.order.use_loyalty_points = this.orderData.loyalty_points_used > 0
            this.order.delivery_instruction = this.orderData.delivery_instruction
            this.order.store_id = this.orderData.store_id
            this.order.store = this.orderData.store
            this.order.payment_channel = this.orderData.payment_channel
            this.order.customer.first_name = this.orderData.user.first_name
            this.order.customer.last_name = this.orderData.user.last_name
            this.order.customer.email = this.orderData.user.email
            this.order.customer.phone = this.orderData.user.phone
            this.order.customer.balance = this.orderData.user.balance
            this.shippingFee = this.orderData.delivery_fee

            this.order.order_items = []
            console.log(this.orderData);
            this.orderData.order_items.forEach((item, index) => {
                let ingredients = [];
                let toppings = [];
                console.log(item.ingredients);
                if (item.ingredients !== null) {
                    item.ingredients.forEach((item) => ingredients.push(item.ingredient_id || item.id));
                }
                if (item.toppings !== null) {
                    item.toppings.forEach((item) => toppings.push(item.topping_id))
                }
                this.order.order_items.push({
                    quantity: item.quantity,
                    product_id: item.product_id,
                    size_id: item.size_id,
                    image_url: item.product.product_images[0].image_url,
                    ingredients,
                    pizza_crust: item.pizza_crust,
                    toppings,
                    product: item.product,
                    size: item.size,
                    price: item.price,
                    subtotal: item.grand_total,
                });

                this.order.product_sizes[index] = item.product.sizes.filter((item) => item.pivot.store_id === this.order.store.id)

                this.order.ingredients[index] = item.product.ingredients
                this.order.has_toppings[index] = item.product.has_toppings
                this.order.has_crust[index] = item.product.has_crust
            });
            this.fetchStoreProduct(this.order.store.id)
        },
    },
    watch: {
        newCustomer() {
            this.order.first_name = '';
            this.order.last_name = '';
        },

        order: {
            async handler(val) {

                if (this.isWatchEnabled) {
                    if (val.type === 'PICKUP') {
                        this.shippingFee = 0
                        this.hasLocation = true;
                        this.outOfCoverageMessage = '';
                    }

                    if (val.type === 'DELIVERY') {
                        if (val.longitude !== null && val.latitude !== null && val.address !== null) {
                            await this.getAddressData({longitude:val.longitude, latitude: val.latitude, address: val.address})
                        }
                    }

                    const newStoreId = val.store?.id;
                    if ((!this.oldStoreId && newStoreId) || (this.oldStoreId !== newStoreId)) {
                        if (!this.isEditing) {
                            this.updateOrderItems()
                        }
                        this.updateOldStoreId(newStoreId)

                        if (this.debounceTimer) {
                            clearTimeout(this.debounceTimer);
                        }

                        // Set up a new debounce timer
                        this.debounceTimer = setTimeout(async () => {
                            await this.fetchStoreProduct(newStoreId);
                        }, 500);
                    }
                }
            }, deep: true
        },
        hasSelectedCustomer(data) {
            if (data && !this.isEditing) {
                const customer = this.order.customer;
                this.order.recipient = {...customer}
            }
        },
        orderType(type) {
            if ((type === 'DELIVERY' && this.hasLocation && this.order.store) || (type === 'PICKUP' && this.hasLocation && this.order.store)) {
                this.fetchStoreProduct(this.order.store.id)
            }
        },
         place(val) {
            if (! this.place?.value?.placeId) return;

            let placeId = this.place.value.placeId;
            let sessionToken = this.place.value.sessionToken;
            let apiKey = this.googleApiKey;

            axios.get(`https://places.googleapis.com/v1/places/${placeId}?sessionToken=${sessionToken}`, {
                headers: {
                    "X-Goog-Api-Key": apiKey,
                    "X-Goog-FieldMask": "id,displayName,formattedAddress,location"
                }
            }).then(async response => {
                await this.addressAutocompleteSearch(response.data)
            }).catch(error => {
                console.error("Error fetching place details:", error);
            });
        }
    },
    created() {
        this.stores = this.dataStores
        this.paymentMethods = this.dataPaymentMethods;
    },
    computed: {
        subTotal() {
            let initialValue = 0;
            if (this.order.store || this.isEditing) {
                return this.order.order_items.reduce((accumulator, currentValue) => {
                    let currCost = currentValue.subtotal ? +currentValue.subtotal : 0;
                    return accumulator + currCost;
                }, initialValue);
            }
            return 0;
        },
        total() {
            // let balance = !this.newCustomer ? (this.order.customer.balance ?? 0) : 0
            let subTotal = parseFloat(this.subTotal) + parseFloat(this.shippingFee);
            return subTotal > 0 ? subTotal : 0;
        },
    },
    mounted() {
        if (this.isEditing) {
            this.mountOrder();
        }
    },
}

</script>

<style scoped>
.column-border {
    border: 1px solid #ccc;
    margin-bottom: 15px;
}

.create-order-form :deep(.customer-search .vs__dropdown-toggle) {
    min-height: calc(1.8125rem + 2px);
    height: calc(1.8125rem + 2px);
    padding: 0 0.25rem;
}

.create-order-form :deep(.order-items-search .vs__dropdown-toggle) {
    min-height: calc(1.8125rem + 2px);
    padding: 0 0.25rem;
}

.create-order-form :deep(.customer-search .vs__selected-options),
.create-order-form :deep(.order-items-search .vs__selected-options) {
    flex-wrap: nowrap;
    overflow: hidden;
}

.create-order-form :deep(.customer-search .vs__selected),
.create-order-form :deep(.order-items-search .vs__selected) {
    margin: 2px 2px 0;
    padding: 0 0.25rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.create-order-form :deep(.customer-search .vs__search),
.create-order-form :deep(.order-items-search .vs__search) {
    margin: 0;
    padding: 0.25rem 0;
}

.create-order-form :deep(.customer-search .vs__actions),
.create-order-form :deep(.order-items-search .vs__actions) {
    padding-top: 0;
}

.create-order-form .form-check-input {
    width: 1.1rem;
    height: 1.1rem;
    margin-top: 0.15rem;
    position: static;
}

.customer-balance-line {
    margin-top: 0.75rem;
    margin-bottom: 1.25rem;
}

.customer-details-fields {
    margin-top: 0.25rem;
}
</style>

<!--[{"ingredient_id":15,"name":"black olives"},{"ingredient_id":10,"name":"mozarella cheese"}]-->
